
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/view-base/abpbase";
import { RoleDto, RegionLimitDto,CreateOrUpdateEdcationPassionInput } from "@/api/service-proxies";

import { userService } from "@/api/userService";

@Component({
  name: "select-record-face-templete",
  components: {},
})
export default class OpendialogRrgin extends Vue {
  isDialogVisible= false
  roles: RoleDto[] = [];
  options=[];
  updateRegion : RegionLimitDto[]=[];
  props = { multiple: true, value: "value" ,checkStrictly:false}; // 多级选择器配置多选
  optionSelect =[];
  submitLodding = false;
  passionInput = new CreateOrUpdateEdcationPassionInput();
  checkList = [];
  open(userid:number){
    this.getRegionUnint();
    this.passionInput.userId = userid;
    this.passionInput.regionLimitDtos = [];
    this.getSelectOption();
    this.isDialogVisible=true;
  }
  //获取省市地区
  getRegionUnint(){
    userService.getOrganizationUnits()
    .then((res)=>{
      this.options=res;
    })
  }

  getSelectOption()
  {
    this.optionSelect=[];
    userService.getSelectRegion(this.passionInput.userId)
    .then((res)=>{
      res.forEach((e)=>{
        var item=[];
        item.push(e.province);
        item.push(e.city);
        item.push(e.district);
        this.optionSelect.push(item)
      })
    })
  }
  done(){
    this.submitLodding = true;
    this.optionSelect.forEach((r)=>{
      this.passionInput.regionLimitDtos.push(new RegionLimitDto({
        province:r[0],
        city:r[1],
        district:r[2],
      }));
    })
    userService.createOrUpdateEdcationPassion(this.passionInput)
    .then((res)=>{
      this.$message.success("更改成功");
    })
    .catch((r)=>{
      this.$message.error("更改失败");
    })
    .finally(()=>{
      this.submitLodding=false
    })
  }

}
